module.exports = __webpack_public_path__ + "img/about5.3a9d20d8.png";